import { Outlet } from 'react-router-dom';
import './HelpPage.css';

/**
 * HelpPage — admin 매뉴얼 페이지 컨테이너.
 *
 * nested route children 으로 sub-매뉴얼 (AdminBulkImportHelp 등) 렌더.
 * AuthGuard 안에서 mount 되므로 인증된 사용자만 접근 — sub-매뉴얼 안에서 추가 role 가드.
 *
 * 본 cycle (`bulk-import-admin-help-pages`) 은 admin bulk import 매뉴얼 1 sub-페이지만.
 * 향후 다른 admin 매뉴얼 (FAQ admin / external profile 등) 신설 시 같은 구조로 children 추가.
 */
export function HelpPage() {
  return (
    <div className="help-page">
      <Outlet />
    </div>
  );
}

export default HelpPage;
